import React from "react";
import {
  GENERIC_CAPTIONM_FONT_SIZE,
  GENERIC_CAPTIONS_FONT_SIZE,
  GENERIC_LABELM_FONT_SIZE,
  GENERIC_PAGE_HEADER_FONT_SIZE,
  GENERIC_PAGE_SUB_HEADER_FONT_SIZE,
  GENERIC_SUBTITLEM_FONT_SIZE,
  GENERIC_SUBTITLES_FONT_SIZE,
} from "../constants/Constants";

export const LabelM = ({ children, style }) => {
  return (
    <h6
      style={{
        fontSize: GENERIC_LABELM_FONT_SIZE,
        fontWeight: "500",
        lineHeight: "25.37px",
        textAlign: "center",
        paddingTop: "15px",
        margin: 0,
        ...style,
      }}
    >
      {children}
    </h6>
  );
};

export const PageHeader = ({ children, style }) => {
  return (
    <h2
      style={{
        fontSize: GENERIC_PAGE_HEADER_FONT_SIZE,
        fontWeight: "700",
        lineHeight: "41.51px",
        textAlign: "left",
        marginBottom: "20px",
        marginTop: "12px",
        ...style,
      }}
    >
      {children}
    </h2>
  );
};

export const PageSubheader = ({ children, style, onClick }) => {
  return (
    <h3
      style={{
        fontSize: GENERIC_PAGE_SUB_HEADER_FONT_SIZE,
        fontWeight: "600",
        lineHeight: "32.28px",
        textAlign: "left",
        marginBottom: "10px",
        marginTop: "10px",
        ...style,
      }}
      onClick={onClick}
    >
      {children}
    </h3>
  );
};

export const SubtitleM = ({ children, style }) => {
  return (
    <p
      style={{
        fontSize: GENERIC_SUBTITLEM_FONT_SIZE,
        fontWeight: "600",
        lineHeight: "27.67px",
        textAlign: "left",
        color: "#0D2855",
        margin: 0,
        ...style,
      }}
    >
      {children}
    </p>
  );
};

export const SubtitleS = ({ children, style }) => {
  return (
    <p
      style={{
        fontSize: GENERIC_SUBTITLES_FONT_SIZE,
        fontWeight: "400",
        lineHeight: "16.14px",
        textAlign: "center",
        color: "#000",
        ...style,
      }}
    >
      {children}
    </p>
  );
};

export const CaptionM = ({ children, style }) => {
  return (
    <p
      style={{
        fontSize: GENERIC_CAPTIONM_FONT_SIZE,
        fontWeight: "300",
        lineHeight: "20.75px",
        textAlign: "center",
        color: "#9DA6B6",
        margin: 0,
        ...style,
      }}
    >
      {children}
    </p>
  );
};

export const CaptionS = ({ children, style }) => {
  return (
    <p
      style={{
        fontSize: GENERIC_CAPTIONS_FONT_SIZE,
        fontWeight: "400",
        lineHeight: "18.45px",
        textAlign: "center",
        color: "#9DA6B6",
        margin: 0,
        ...style,
      }}
    >
      {children}
    </p>
  );
};

export const InfoText = ({ children, style }) => {
  return (
    <p
      style={{
        fontSize: "14px",
        fontWeight: "400",
        lineHeight: "16.14px",
        textAlign: "center",
        color: "#9DA6B6",
        ...style,
      }}
    >
      {children}
    </p>
  );
};

export const SmallHeader = ({ children, style }) => {
  return (
    <span
      style={{
        fontSize: "16px",
        fontWeight: "400",
        lineHeight: "16.14px",
        textAlign: "left",
        letterSpacing: "0.5px",
        ...style,
      }}
    >
      {children}
    </span>
  );
};
